import { z } from "zod";

export const FormSchema = z.object({
  cpf: z
    .string({ message: "CPF inválido" })
    .regex(/^\d{11}$/, "CPF deve conter exatamente 11 dígitos numéricos"),
  name: z.string().optional(),
  matricula: z.string().optional(),
  cargo: z.string().optional(),
  situation: z.string().optional(),
  cost_center: z.string().optional(),
  store: z.string().optional(),
});

export type FormData = z.infer<typeof FormSchema>;
